var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    transform: "rotate(90 24 24)",
    fill: "url(#paint0_linear_1032_37089)",
    stroke: "url(#paint1_linear_1032_37089)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 15C24.2652 15 24.5195 15.1054 24.7071 15.2929C24.8946 15.4804 25 15.7348 25 16L25 29.586L30.292 24.292C30.3849 24.199 30.4953 24.1253 30.6168 24.075C30.7383 24.0246 30.8685 23.9987 31 23.9987C31.1314 23.9987 31.2616 24.0246 31.3831 24.075C31.5046 24.1253 31.615 24.199 31.708 24.292C31.8009 24.385 31.8747 24.4954 31.925 24.6168C31.9753 24.7383 32.0012 24.8685 32.0012 25C32.0012 25.1315 31.9753 25.2617 31.925 25.3832C31.8747 25.5046 31.8009 25.615 31.708 25.708L24.708 32.708C24.6151 32.8011 24.5047 32.875 24.3832 32.9254C24.2617 32.9758 24.1315 33.0018 24 33.0018C23.8684 33.0018 23.7382 32.9758 23.6167 32.9254C23.4952 32.875 23.3848 32.8011 23.292 32.708L16.292 25.708C16.1042 25.5202 15.9987 25.2656 15.9987 25C15.9987 24.7344 16.1042 24.4798 16.292 24.292C16.4797 24.1042 16.7344 23.9987 17 23.9987C17.2655 23.9987 17.5202 24.1042 17.708 24.292L23 29.586L23 16C23 15.7348 23.1053 15.4804 23.2929 15.2929C23.4804 15.1054 23.7347 15 24 15Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1032_37089",
    x1: -0.00000190735,
    y1: 24,
    x2: 48,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1032_37089",
    x1: -0.00000190735,
    y1: 24,
    x2: 48,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C1FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A06B8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.b9d46fad858e7207628c17545aaed06f.svg";
export { ForwardRef as ReactComponent };